const Summary = () => {
    return (
        <div className="bg-darkGrey rounded-[4px] p-4">
            <div className="flex justify-between mb-4 text-[#979797] text-[12px]">
                <div>Total money of investors</div>
                <div >P/L</div>
            </div>
            <div className="flex justify-between text-white text-[16px] font-bold">
                <div >$4500</div>
                <div>$400</div>
            </div>
        </div> 
    );
}
 
export default Summary;